export default "__VITE_ASSET__CM8aeN8S__"